export default (job, key) => {
  const param = job.params.filter(p => p.key === key);
  if (param.length > 0) {
    return param[0].value;
  }
  return null;
};
